import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllDokumenLoss = createAsyncThunk(
  "dokumen/GetAllDokumenLoss",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/dokumen`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllDokumen = createAsyncThunk(
  "dokumen/GetAllDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/dokumen/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleDokumen = createAsyncThunk(
  "dokumen/GetSingleDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/dokumen/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateDokumen = createAsyncThunk(
  "dokumen/CreateDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/dokumen`,
        {
          nama: data.nama,
          deskripsi: data.deskripsi,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditDokumen = createAsyncThunk(
  "dokumen/EditDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/dokumen/${data.id}`,
        {
          nama: data.nama,
          deskripsi: data.deskripsi,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteDokumen = createAsyncThunk(
  "dokumen/DeleteDokumen",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/dokumen/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(`${api}master/dokumen/all?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const dokumenSlice = createSlice({
  name: "dokumen",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all dokumen without pagination
    builder.addCase(GetAllDokumenLoss.pending, loadingHandler);
    builder.addCase(GetAllDokumenLoss.fulfilled, fulfilledHandler);
    builder.addCase(GetAllDokumenLoss.rejected, rejectedHandler);
    // get all dokumen
    builder.addCase(GetAllDokumen.pending, loadingHandler);
    builder.addCase(GetAllDokumen.fulfilled, fulfilledHandler);
    builder.addCase(GetAllDokumen.rejected, rejectedHandler);
    // get Single dokumen
    builder.addCase(GetSingleDokumen.pending, loadingHandler);
    builder.addCase(GetSingleDokumen.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleDokumen.rejected, rejectedHandler);
    // create dokumen
    builder.addCase(CreateDokumen.pending, loadingHandler);
    builder.addCase(CreateDokumen.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateDokumen.rejected, rejectedHandler);
    // edit dokumen
    builder.addCase(EditDokumen.pending, loadingHandler);
    builder.addCase(EditDokumen.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditDokumen.rejected, rejectedHandler);
    // delete dokumen
    builder.addCase(DeleteDokumen.pending, loadingHandler);
    builder.addCase(DeleteDokumen.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteDokumen.rejected, rejectedHandler);
  },
});

export const { reset } = dokumenSlice.actions;
export default dokumenSlice.reducer;
